import { Chip, TableCell } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { EnforcementState, PolicyAction } from "~/operations";

// Reusable chip component for SCORED/PREVIEW status
export function StatusChip({ isPreview }: { isPreview: boolean }) {
  const color = isPreview ? "text.disabled" : "none.main";
  return (
    <Chip
      label={isPreview ? "PREVIEW" : "SCORED"}
      size="small"
      variant="outlined"
      sx={{
        fontWeight: 600,
        fontSize: 12,
        borderRadius: 1,
        color: color,
        borderColor: color,
      }}
    />
  );
}

// TableCell version for use in regular tables (e.g., FirewatchRow)
interface PreviewStatusCellProps {
  enforcementState: EnforcementState;
  "data-testid"?: string;
}

export function PreviewStatusCell({
  enforcementState,
  ...props
}: PreviewStatusCellProps) {
  const isPreview = enforcementState === EnforcementState.Preview;
  return (
    <TableCell data-testid={props["data-testid"]}>
      <StatusChip isPreview={isPreview} />
    </TableCell>
  );
}

// DataGrid version for use with MUI DataGrid (e.g., RelatedPolicies)
export function StatusCell(params: GridRenderCellParams<any, PolicyAction>) {
  const isPreview = params.value === PolicyAction.Ignore;
  return <StatusChip isPreview={isPreview} />;
}
